import { IBizzaboSectionData, ICustomPrice, IPrice } from '../../interface'
import AccordionLayout from './AccordionLayout'
import BizzaboAccordionContent from './BizzaboAccordionContent'
import CustomAccordionContent from './CustomAccordionContent'

interface IAccordionContent {
  index: number
  item: IPrice | ICustomPrice
  expanded: number | false
  handleExpandedChange: (panel: number) => void
  product?: string
  sectionData: IBizzaboSectionData[]
}

const AccordionContent = ({ index, item, expanded, handleExpandedChange, product, sectionData }: IAccordionContent) => {
  const isBizzaboPrice = (data: IPrice | ICustomPrice): data is IPrice => {
    return (data as IPrice).availableDates !== undefined
  }

  const renderContent = () => {
    if (isBizzaboPrice(item)) {
      return <BizzaboAccordionContent data={item} dates={item.availableDates} sectionData={sectionData} />
    }
    return product ? <CustomAccordionContent data={item} /> : null
  }

  return (
    <AccordionLayout
      index={index}
      title={isBizzaboPrice(item) ? item.metadata._version : item.title}
      expanded={expanded}
      handleExpandedChange={handleExpandedChange}
    >
      {renderContent()}
    </AccordionLayout>
  )
}

export default AccordionContent
